import React from "react";

interface Props {
  /** Displays a short descriptive keyword in a pill container */
  "children": string;

  /** Specify the class name for current component */
  "className"?: string;

  /** The background color variant */
  "color"?: "primary" | "secondary" | "alert";

  /** Specify the testid for current component */
  "data-testid"?: string;
}

export const BadgeTag: React.FC<Props> = ({
  children,
  className,
  color = "primary",
  "data-testid": dataTestId,
}) => {
  const colors = {
    primary: "bg-brand-color text-white",
    secondary: "bg-brand-color/10 text-brand-color",
    alert: "text-white bg-text-primary",
  };

  const classNames = className
    ? `${className} ${colors[color]}`
    : `flex w-fit items-center gap-1.5 rounded-full px-2.5 py-1 text-bold2 ${colors[color]}`;

  return (
    <div className={classNames} data-testid={dataTestId}>
      {color === "alert" && (
        <div className="h-2.5 w-2.5 rounded-full bg-red">
          <div className="h-full w-full animate-ping rounded-full bg-inherit" />
        </div>
      )}
      {children}
    </div>
  );
};
